// onsiparis: sepet uyarı bandının görünürlüğünü canlı tutar.
// Temannın sepeti hangi yöntemle güncellediğini (kısmi DOM yaması,
// tüm seçsiyonu değiştirme, vb.) bilmemize gerek kalmadan çalışsın diye
// hem MutationObserver hem de kısa aralıklı bir kontrol (polling) birlikte
// kullanılıyor. Düzenli aralıklarla sayfadaki GERÇEK DOM durumuna bakılıp
// banner'lar buna göre gösterilip gizleniyor; böylece hangi yöntemle
// güncellenirse güncellensin en geç ~400ms içinde doğru duruma döner.
(function () {
  function refresh() {
    var hasPreorder = !!document.querySelector('[data-preorder-item="true"]');
    var notices = document.querySelectorAll('[data-preorder-cart-notice]');
    for (var i = 0; i < notices.length; i++) {
      notices[i].classList.toggle('hidden', !hasPreorder);
    }
  }

  function init() {
    refresh();

    var observer = new MutationObserver(refresh);
    observer.observe(document.body, { childList: true, subtree: true });

    // Emniyet ağı: MutationObserver bir değişikliği kaçırırsa bile
    // en geç 400ms içinde durum kendiliğinden düzelir.
    setInterval(refresh, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
